// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oti6B","actions":"styles_actions__3S1-t","error":"styles_error__2RR_m","message":"styles_message__13J3y"};